<mat-form-field appearance="fill" class="language-button">
  <mat-select class="select-language" required [(ngModel)]="selectedLanguage" (selectionChange)="changeLanguage(selectedLanguage)">
    <mat-option class="language-option" *ngFor="let lang of languages" [value]="lang">
      <span>{{ lang }}</span>
    </mat-option>
  </mat-select>
</mat-form-field>
